<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" matSort [data]="processingTimes$ | async" [selectionVisible]="false">
    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let pTime">
        <span class="layout-row place-start-center">
          <mat-icon>timer</mat-icon>
        </span>
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 25%">
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let pTime">
        <div class="layout-col">
          <div>{{ pTime.spec.description }}</div>
          <div class="text-body-small">{{ pTime.spec.property.id }}</div>
        </div>
      </td>
    </ng-container>

    <!-- variantSet Column -->
    <ng-container matColumnDef="variantSet">
      <th mat-header-cell *matHeaderCellDef style="width: 15%">
        {{ 'context.group' | translate }}
      </th>
      <td mat-cell *matCellDef="let pTime">{{ pTime.setNumber }}</td>
    </ng-container>

    <!-- quantity Column -->
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">
        {{ 'context.quantity' | translate }}
      </th>
      <td mat-cell *matCellDef="let pTime; let i = index">
        <mat-form-field subscriptSizing="dynamic" elderDense>
          <elder-quantity-input name="{{ name + 'quantity' + i }}" [(ngModel)]="pTime.unitQuantity">
          </elder-quantity-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- duration Column -->
    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" matTooltip="e.g. PT12H30M5S">
        {{ 'context.duration' | translate }}
      </th>
      <td mat-cell *matCellDef="let pTime; let i = index">
        <mat-form-field subscriptSizing="dynamic" elderDense>
          <elder-duration-input
            [placeholder]="'Initial'"
            [(isoValue)]="pTime.duration"
            [format]="'hh:mm'"
          ></elder-duration-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </td>
    </ng-container>
  </elder-table>
</div>
